import 'css-chunksrc/client/scenes/optimizedGantt/calendar/years/styles.scss';export default {
  "years": "_years_rtqon_1",
  "year": "_year_rtqon_1"
};